<template>
  <div v-resize="setContentHeight" class="search-result">
    <v-toolbar dark color="primary" class="pr-1">
      <v-btn icon @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>Search Results</v-toolbar-title>
    </v-toolbar>

    <div v-if="searchResponse && searchResponse.areas">
      <v-card
        tile
        class="px-2 py-2 mb-1 text-small font-weight-bold primary--text"
        style="border-bottom-left-radius: 3px; border-bottom-right-radius: 3px"
      >
        <div v-if="searchResponse.found">
          <v-row no-gutters>
            <v-col class="col-1">
              <v-icon class="icon-small">mdi-information</v-icon>
            </v-col>
            <v-col>
              {{ searchResponse.areas.length }} result{{
                searchResponse.areas.length === 1 ? "" : "s"
              }}
              found.
            </v-col>
          </v-row>
        </div>
        <div v-else class="red--text">
          <v-row no-gutters>
            <v-col class="col-1">
              <v-icon color="red" class="icon-small">mdi-alert</v-icon>
            </v-col>
            <v-col>
              No matching results found. Other suggested slots below:
            </v-col>
          </v-row>
        </div>
      </v-card>

      <div ref="searchResultsScrollable" class="scrollable">
        <v-card
          v-for="(area, i) in searchResponse.areas"
          :key="i"
          tile
          class="mb-1"
          @click="showBookingDetails(area)"
        >
          <v-row no-gutters>
            <v-col class="col-3 flex-center-left-container">
              <v-img
                class="ma-1x"
                :src="`${areaImagePath}${area.areaImageUrls[0]}`"
                aspect-ratio="1"
                max-height="100"
                max-width="100"
              />

              <!-- <v-img
              class="ma-1x"
              :src="require(`@/assets/images/trl-study-lounge.png`)"
              aspect-ratio="1"
              max-height="100"
              max-width="100"
              />-->

              <!-- :src="require(`@/assets/images/${area.image}`)" -->
            </v-col>
            <v-col class="col-9 pl-4 pt-5x" style="padding-top: 16px">
              <v-row no-gutters class="pb-2">
                <v-col class="text-title-black text-truncate">{{
                  formatLocation(area.areaName, area.floor)
                }}</v-col>
              </v-row>
              <v-row no-gutters class="text-small">
                <v-col class="col-12">
                  <span class="pr-3">
                    <v-icon class="icon-smaller">mdi-clock-outline</v-icon>
                    {{ formatPeriod(area.startTime, area.endTime) }}
                  </span>
                  <span>
                    <v-icon class="icon-small" style="padding-right: 5px"
                      >mdi-seat</v-icon
                    >
                    {{
                      formatAvailability(
                        area.availableSeatsCount,
                        area.totalSeatCount
                      )
                    }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import formatters from "@/helpers/formatters";
import constants from "@/helpers/constants";

export default {
  // props: {
  //   searchResponse: Object,
  // },
  data: () => ({
    searchResponse: null,
  }),
  computed: {
    ...mapState(["searchResults"]),
  },
  methods: {
    ...mapMutations(["updateSelectedArea"]),
    showBookingDetails(area) {
      this.updateSelectedArea(area);
      this.$router.push({
        name: "BookingDetails",
        params: { selectedSeatName: this.searchResponse.selectedSeatName },
      });
    },
    formatLocation(area, floor) {
      return `${area}, Level ${floor}`;
    },
    formatPeriod(fromDateString, toDateString) {
      return formatters.formatPeriod(fromDateString, toDateString);
    },
    formatAvailability(availableSeatsCount, totalSeatCount) {
      return `${availableSeatsCount}/${totalSeatCount}`;
    },
    setContentHeight() {
      if (this.$refs.searchResultsScrollable) {
        const heights = this.heights();
        const contentHeight =
          heights.screen - heights.toolbar - heights.headerbar - heights.noticeBarHeight;

        this.$refs.searchResultsScrollable.style.height = contentHeight + "px";
      }
    },
  },
  activated() {
    this.searchResponse = this.searchResults;

    this.$nextTick(() => this.setContentHeight());
  },
};
</script>